import { render } from "./Template.vue?vue&type=template&id=5ed30ef8&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5ed30ef8"

export default script